import { useEffect, useRef, useState } from "react";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";

import ReactCountryFlag from "react-country-flag";

//Props Validations
import PropTypes from "prop-types";

//import helper
import { useSelector } from "react-redux";

const idetifierLabelMap = {
    businessGroup: "Business Group",
    studyType: "Study Type",
    "Blind/Branded/Full Mix": "Blind/Branded/Full Mix",
    CBP: "CBP",
    studyTypeMethod: "Study Type Method",
    country: "Country",
    unileverBrand: "Unilever Brand",
    deodorantFormat: "Product Format",
    studyPeriod: "Study Period",
};

function FiltersHeaderLabel({ multipleLabel = false }) {
    const studyPageFilters = useSelector((state) => state.studyDataStore.studyPageFilters);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const businessGroupData = useSelector((state) => state.settingsStore.businessGroup);

    const [businessGroupLabels, setBusinessGroupLabels] = useState([]);
    const [studyTypeLabels, setStudyTypeLabels] = useState([]);
    const [blindBrandedFullMixLabels, setBlindBrandedFullMixLabels] = useState([]);
    const [CBPLabels, setCBPLabels] = useState([]);
    const [studyTypeMethodLabels, setStudyTypeMethodLabels] = useState([]);
    const [productCategoryLabels, setProductCategoryLabels] = useState([]);
    const [countryLabels, setCountryLabels] = useState([]);
    const [unileverBrandLabels, setUnileverBrandLabels] = useState([]);
    const [deodorantFormatLabels, setDeodorantFormatLabels] = useState([]);
    const [studyPeriodLabels, setStudyPeriodLabels] = useState([]);
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellbeing = isHairCare || isSkinCare; 
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const scrollRef = useRef(null);

    useEffect(() => {
        if (businessGroupData) {
            setBusinessGroupLabels(businessGroupData.label);
        }
        if (productCategoryData) {
            setProductCategoryLabels(productCategoryData.label);
        }
        if (Object.keys(studyPageFilters).length) {
            if (studyPageFilters?.studyType) {
                const labels = studyPageFilters.studyType
                    .filter((ele) => {
                        if (ele.checked === true) {
                            return ele;
                        }
                    })
                    .map((datum) => datum.label);
                setStudyTypeLabels(labels);
            }
            if (studyPageFilters?.["Blind/Branded/Full Mix"]) {
                const labels = studyPageFilters["Blind/Branded/Full Mix"]
                    .filter((ele) => {
                        if (ele.checked === true) {
                            return ele;
                        }
                    })
                    .map((datum) => datum.label);
                setBlindBrandedFullMixLabels(labels);
            }
            if (studyPageFilters?.CBP) {
                const labels = studyPageFilters.CBP.filter((ele) => {
                    if (ele.checked === true) {
                        return ele;
                    }
                }).map((datum) => datum.label);
                setCBPLabels(labels);
            }
            if (studyPageFilters?.studyTypeMethod) {
                const labels = studyPageFilters.studyTypeMethod
                    .filter((ele) => {
                        if (ele.checked === true) {
                            return ele;
                        }
                    })
                    .map((datum) => datum.label);
                setStudyTypeMethodLabels(labels);
            }
            if (studyPageFilters?.country) {
                const labels = studyPageFilters.country
                    .filter((ele) => {
                        if (ele.checked === true) {
                            return ele;
                        }
                    })
                    .map((datum) => {
                        return {
                            label: datum.label,
                            description: datum.description,
                        };
                    });
                setCountryLabels(labels);
            }
            if (studyPageFilters?.unileverBrand) {
                const labels = studyPageFilters.unileverBrand
                    .filter((ele) => {
                        if (ele.checked === true) {
                            return ele;
                        }
                    })
                    .map((datum) => datum.label);
                setUnileverBrandLabels(labels);
            }
            if (studyPageFilters?.deodorantFormat) {
                const labels = studyPageFilters.deodorantFormat
                    .filter((ele) => {
                        if (ele.checked === true) {
                            return ele;
                        }
                    })
                    .map((datum) => datum.label);
                setDeodorantFormatLabels(labels);
            }
            if (studyPageFilters?.studyPeriod) {
                const labels = studyPageFilters.studyPeriod
                    .filter((ele) => {
                        if (ele.checked === true) {
                            return ele;
                        }
                    })
                    .map((datum) => datum.label);
                setStudyPeriodLabels(labels);
            }
        }
    }, [studyPageFilters, productCategoryData, businessGroupData]);

    const handleScroll = (direction) => {
        if (!scrollRef.current) return;

        scrollRef.current.scrollBy({
            left: direction === "right" ? 250 : -250,
            behavior: "smooth",
        });
    };
    const returnSeperator = () => {
        return (
            <span
                style={{
                    margin: "auto 0px",
                }}
            >
                |
            </span>
        );
    };

    const returnLabel = (identifier, labels, first = false, last = false) => {
        const renderLabel = () => {
            if (labels.length === 1) {
                if (identifier === "country") {
                    return (
                        <span
                            className="ps-0 pe-3 text-bold-5 text-xs"
                            style={{ margin: "auto 0px" }}
                        >
                            <ReactCountryFlag
                                countryCode={labels[0].description}
                                svg
                                style={{
                                    width: "1.5em",
                                    height: "1.5em",
                                    marginRight: "10px",
                                }}
                            />
                            {labels[0].label}
                        </span>
                    );
                }
                return (
                    <span
                        className="ps-0 pe-3 text-bold-5 text-xs"
                        style={{ margin: "auto 0px" }}
                    >
                        {labels[0]}
                    </span>
                );
            }
            return (
                <span
                    className="ps-0 pe-3 text-bold-5 text-xs"
                    style={{ margin: "auto 0px" }}
                >
                    Multiple
                </span>
            );
        };

        return (
            <>
                {first && returnSeperator()}
                <span
                    className="ps-2 pe-0 text-bold-6 text-xs"
                    style={{ margin: "auto 0px" }}
                >
                    {isSkinCare && identifier === "Blind/Branded/Full Mix" ? "Blind/Branded" : idetifierLabelMap[identifier]}:&nbsp;
                </span>
                {renderLabel()}
                {!last && returnSeperator()}
            </>
        );
    };

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
            }}
        >
            <div
                ref={scrollRef}
                style={{
                    flex: 1,
                    minWidth: 0,
                    overflowX: "hidden",
                    whiteSpace: "nowrap",
                    scrollBehavior: "smooth",
                }}
            >
        <span
            className="ps-2"
            style={{
                fontSize: "12px",
                color: "#005eef",
                padding: "10px 0px",
                alignItems: "baseline",
                display: "flex",
            }}
        >
            {/* Business Group*/}
            <span
                className="ps-2 pe-0 text-bold-6 text-xs"
                style={{
                    margin: "auto 0px",
                }}
            >
                Business Group:&nbsp;
            </span>
            <span
                className="ps-0 pe-3 text-bold-5 text-xs"
                style={{
                    margin: "auto 0px",
                }}
                    >
                        {businessGroupLabels}
                    </span>
                    {!(isUnileverFragranceHouse) && (
                        <>
                            {/* Product Category*/}
                            {returnSeperator()}
                            <span
                                className="ps-2 pe-0 text-bold-6 text-xs"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                Product Category:&nbsp;
                            </span>
                            <span
                                className="ps-0 pe-3 text-bold-5 text-xs"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                {productCategoryLabels}
                            </span>
                        </>
                    )}

                    {multipleLabel && (
                        <>
                            {studyTypeLabels.length !== 0 && <>{returnLabel("studyType", studyTypeLabels, true)}</>}
                            {isHairCare && (
                                <>
                                    {blindBrandedFullMixLabels.length !== 0 && returnLabel("Blind/Branded/Full Mix", blindBrandedFullMixLabels)}
                                    {CBPLabels.length !== 0 && returnLabel("CBP", CBPLabels)}
                                </>)}
                            {isSkinCare && (<>{blindBrandedFullMixLabels.length !== 0 && returnLabel("Blind/Branded/Full Mix", blindBrandedFullMixLabels)}</>)}
                            {studyTypeMethodLabels.length !== 0 && <>{returnLabel("studyTypeMethod", studyTypeMethodLabels)}</>}
                            {countryLabels.length !== 0 && <>{returnLabel("country", countryLabels)}</>}
                            {unileverBrandLabels.length !== 0 && <>{returnLabel("unileverBrand", unileverBrandLabels)}</>}
                            {deodorantFormatLabels.length !== 0 && <>{returnLabel("deodorantFormat", deodorantFormatLabels)}</>}
                            {studyPeriodLabels.length !== 0 && <>{returnLabel("studyPeriod", studyPeriodLabels, false, true)}</>}{" "}
                        </>
                    )}
                </span>
            </div>
            {isBeautyAndWellbeing && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 12,
                        flexShrink: 0,
                        width: 80,
                        height: "100%",
                        background: "#fff",
                        borderRadius: "0 6px 6px 0",
                    }}
                >
                    <IconButton
                        onClick={() => handleScroll("left")}
                        sx={{
                            width: 25,
                            height: 25,
                            backgroundColor: "#f0f0f0",
                            "&:hover": {
                                backgroundColor: "#e4e4e4",
                            },
                        }}
                    >
                        <ChevronLeftIcon sx={{ color: "#005eef", fontSize: 30 }} />
                    </IconButton>

                    <IconButton
                        onClick={() => handleScroll("right")}
                        sx={{
                            width: 25,
                            height: 25,
                            backgroundColor: "#f0f0f0",
                            "&:hover": {
                                backgroundColor: "#e4e4e4",
                            },
                        }}
                    >
                        <ChevronRightIcon sx={{ color: "#005eef", fontSize: 30 }} />
                    </IconButton>
                </div>
            )}
        </div>
    );
}
FiltersHeaderLabel.propTypes = {
    multipleLabel: PropTypes.bool,
};
export default FiltersHeaderLabel;
